import { render, staticRenderFns } from "./booking-table.vue?vue&type=template&id=6b52796c&scoped=true&"
import script from "./booking-table.ts?vue&type=script&lang=ts&"
export * from "./booking-table.ts?vue&type=script&lang=ts&"
import style0 from "./booking-table.scss?vue&type=style&index=0&id=6b52796c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52796c",
  null
  
)

export default component.exports